module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("\n    跑步按钮广告 >\n    "), (_vm.edit === false) ? _c('span', [_vm._v("新增")]) : _vm._e(), _vm._v(" "), (_vm.edit !== false && !_vm.isLook) ? _c('span', [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (_vm.edit !== false && _vm.isLook) ? _c('span', [_vm._v("查看")]) : _vm._e(), _vm._v(" "), _c('span', [_c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), (!_vm.isLook) ? _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form,
      "label-width": "170px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称:",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "type": "text",
      "placeholder": "app不展示，仅提供后台标记管理",
      "maxlength": 20,
      "show-word-limit": "",
      "disabled": _vm.isLook
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "按钮图片:",
      "prop": "imgUrl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    style: ({
      'pointer-events': _vm.isLook ? 'none' : ''
    }),
    attrs: {
      "action": _vm.actionUrl,
      "with-credentials": true,
      "accept": "image/*",
      "name": "uploadFile",
      "type": "drag",
      "thumbnail-mode": true,
      "on-error": _vm.handleError,
      "show-file-list": false,
      "on-success": _vm.chenggong
    }
  }, [(_vm.form.imgUrl) ? _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.form.imgUrl
    }
  }) : _c('div', [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("\n            将文件拖到此处，或\n            "), _c('em', [_vm._v("点击上传")])])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发布时间:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择发布日期时间",
      "disabled": _vm.isLook,
      "clearable": false
    },
    model: {
      value: (_vm.form.startTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "startTime", $$v)
      },
      expression: "form.startTime"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.isLook
    },
    on: {
      "click": function($event) {
        _vm.form.startTime = ''
      }
    }
  }, [_vm._v("清除时间")]), _vm._v("\n\n      如不选，择默认直接发布\n    ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "失效时间:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择失效日期时间",
      "disabled": _vm.isLook,
      "clearable": false
    },
    model: {
      value: (_vm.form.endTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "endTime", $$v)
      },
      expression: "form.endTime"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.isLook
    },
    on: {
      "click": function($event) {
        _vm.form.endTime = ''
      }
    }
  }, [_vm._v("清除时间")]), _vm._v("\n\n      如不选，择默认不会自动失效\n    ")], 1), _vm._v(" "), _c('select-school', {
    attrs: {
      "disabled": _vm.isLook,
      "schObj": _vm.form.schObj,
      "isRoot": _vm.isRoot
    },
    on: {
      "changeVal": _vm.getVal
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75041dff!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/runBtn/addRunBtn.vue
// module id = 1076
// module chunks = 0